import React from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useWatchButton } from '../../../WatchButton/useWatchButton';
import s from './WatchButton.scss';
var WatchButton = function (_a) {
    var user = _a.user;
    var _b = useWatchButton(user), isWatching = _b.isWatching, text = _b.text, onClick = _b.onClick, biData = _b.biData;
    var isEllipsisHeaderFlagEnabled = useFlag('dev_page_ellipsis_header');
    if (isEllipsisHeaderFlagEnabled) {
        return (React.createElement(TextButton, { className: s['root'], size: "small", variant: "approval-green", icon: isWatching ? CheckIcon : AddIcon, onClick: onClick, biData: biData }, text));
    }
    return (React.createElement(GhostButton, { size: "small", variant: "main", biData: biData, icon: isWatching ? CheckIcon : AddIcon, onClick: onClick, "data-hook": BiDataHook.USER_WATCH_BUTTON }, text));
};
WatchButton.displayName = 'WatchButton';
export default WatchButton;
//# sourceMappingURL=WatchButton.js.map